export default __webpack_public_path__ + "static/media/gallery_00.956ced93.jpg";